import { StylesConfig } from '@/components/controls/Button/types'
import { hexToRgb } from '@/helpers/hexToRgb'
import theme from '../theme'

export const MOSS_STYLE_TYPE_COLORS: StylesConfig = {
    primary: {
        original: {
            background: theme.colors.moss[500],
            border: theme.colors.moss[500],
            color: theme.colors.base.white
        },
        hover: {
            background: theme.colors.moss[700],
            border: theme.colors.moss[700]
        },
        disabled: {
            background: theme.colors.moss[200],
            border: theme.colors.moss[200]
        }
    },
    secondary: {
        original: {
            background: theme.colors.base.white,
            border: theme.colors.moss[200],
            color: theme.colors.moss[500]
        },
        hover: {
            border: theme.colors.moss[500]
        },
        disabled: {
            border: theme.colors.moss[50],
            color: theme.colors.moss[300]
        }
    },
    tertiary: {
        original: { color: theme.colors.moss[500] },
        hover: {
            background: hexToRgb(theme.colors.moss[500], 0.1),
            border: hexToRgb(theme.colors.moss[500], 0.1)
        },
        disabled: { color: theme.colors.gray[300] }
    },
    link: {
        original: { color: theme.colors.moss[500] },
        hover: { color: theme.colors.moss[700] },
        disabled: { color: theme.colors.gray[300] }
    }
}
